import React, {useEffect, useState} from 'react'
import {
    DatePicker
} from '@material-ui/pickers'
import '../assets/satistics.scss'
import Button from '@material-ui/core/Button'
import {makeStyles} from '@material-ui/core/styles'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'
import httpRequest from '../components/request-api'
import {withRouter} from 'react-router'
import ReactApexChart from 'react-apexcharts'
import {withNamespaces} from 'react-i18next'

const useStyles = makeStyles((theme) => ({
    submitButton: {
        display: 'block',
        marginTop: '8px',
        height: '47px',
        textTransform: 'unset',
        ['@media (max-width:768px)']: {
            fontSize: '12px',
            height: '42px',
        }
    },
    buttonProgress: {
        color: 'white',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}))

function Statistics(props) {
    const t = props.t
    const memberCode = props.match.params.id
    const [toDate, toDateChanged] = useState(moment())
    const [fromDate, fromDateChanged] = useState(moment().subtract(1, 'years'))
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({})
    const [chartSeries, setChartSeries] = useState([{
        name: 'Value',
        data: [0, 0, 0, 0, 0, 0, 0, 0]
    }])
    const classes = useStyles()

    const chartOptions = {
        chart: {
            height: 350,
            type: 'bar',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top',
                },
                endingShape: 'rounded',
                columnWidth: 20,
            }
        },
        fill: {
          colors: ['#5485D2']
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val + "%";
            },
            offsetY: -20,
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        xaxis: {
            categories: ['Hole In One', 'Albatross', 'Eagle', 'Birdie', 'Par', 'Bogey', 'D. Bogey', 'More'],
            position: 'bottom',
            labels: {
                show: true,
                rotateAlways: true,
            },
        },
        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
                formatter: function (val) {
                    return val + "%";
                }
            }
        },
    }

    useEffect(() => {
        submit(fromDate, toDate)
    }, [])

    const submit = (fromDate, toDate) => {
        setLoading(true)
        fromDate = fromDate.format('DD/MM/yyyy')
        toDate = toDate.format('DD/MM/yyyy')

        httpRequest.statistic(memberCode, fromDate, toDate).then((result) => {
            const response = result.data.result
            const statusPercentage = response['status_percentage']

            setData(response)
            setChartSeries([
                {
                    name: 'Value',
                    data: [
                        statusPercentage['hole_in_one'],
                        statusPercentage['albatross'],
                        statusPercentage['eagle'],
                        statusPercentage['birdie'],
                        statusPercentage['par'],
                        statusPercentage['bogey'],
                        statusPercentage['double_bogey'],
                        statusPercentage['more'],
                    ]
                }
            ])
        }).finally(() => setLoading(false))
    }

    const courseName = (course) => {
        const lang = localStorage.getItem('i18nextLng')

        if (lang === 'en' && course['name_en'] && course['name_en'] !== '-') {
            return course['name_en']
        } else if (lang === 'th' && course['name_th'] && course['name_th'] !== '-') {
            return course['name_th']
        } else {
            if (course['name_en'] && course['name_en'] !== '-') {
                return course['name_en']
            } else if(course['name_th'] && course['name_th'] !== '-') {
                return course['name_th']
            }

            return '-'
        }
    }

    return (
        <React.Fragment>
            <h3 className="text-left mt-3 title">{t('period')}</h3>
            <div className="row no-gutters statistic-date-picker-box">
                <div className="col-4 col-lg-2 col-md-4">
                    <DatePicker
                        margin="dense"
                        id="fromDate"
                        label={t('from')}
                        format="DD/MM/yyyy"
                        inputVariant="filled"
                        onChange={fromDateChanged}
                        value={fromDate}
                        fullWidth
                        autoOk
                    />
                </div>
                <div className="col-4 col-lg-2 col-md-4">
                    <DatePicker
                        margin="dense"
                        id="toDate"
                        label={t('to')}
                        format="DD/MM/yyyy"
                        inputVariant="filled"
                        onChange={toDateChanged}
                        value={toDate}
                        fullWidth
                        autoOk
                    />
                </div>
                <div className="col-4 col-lg-2 col-md-4 btn-submit-box">
                    <Button
                        className={classes.submitButton}
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => submit(fromDate, toDate)}
                        disabled={loading}
                    >
                        {t('reCalculate')}
                    </Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
            </div>
            <div className="row mt-4 text-left">
                <div className="col-12 col-sm-3">
                    {t('averageScore')}
                </div>
                <div className="col-12 col-sm-3">
                    {data.hasOwnProperty('score') ? data['score']['average_score'] : 0}
                </div>
                <div className="col-12 col-sm-3">
                    {t('worstScore')}
                </div>
                <div className="col-12 col-sm-3">
                    {data.hasOwnProperty('score') ? data['score']['worst_score'] : 0}
                </div>
            </div>
            <div className="row mt-sm-3 text-left">
                <div className="col-12 col-sm-3">
                    {t('numberOfRecords')}
                </div>
                <div className="col-12 col-sm-3">
                    {data['total_records']}
                </div>
                <div className="col-12 col-sm-3">
                    {t('bestScore')}
                </div>
                <div className="col-12 col-sm-3">
                    {data.hasOwnProperty('score') ? data['score']['best_score'] : 0}
                </div>
            </div>
            <ReactApexChart className="mt-4" options={chartOptions} series={chartSeries} type="bar" height={350} />
            <h5 className="text-left mt-4">{t('coursePlayingStatistics')}</h5>
            <table>
                <thead>
                    <tr>
                        <th className="text-left">{t('golfCourseTitle')}</th>
                        <th>{t('noRecords')}</th>
                        <th>{t('averageScore')}</th>
                    </tr>
                </thead>
                <tbody>
                {
                    data.hasOwnProperty('courses') ? data['courses'].map((course, i) => (
                        <tr key={i}>
                            <td className="text-left">{courseName(course)}</td>
                            <td>{course.total_records}</td>
                            <td>{course.average_score}</td>
                        </tr>
                    )) : null
                }
                </tbody>
            </table>
        </React.Fragment>
    )
}

export default withNamespaces()(withRouter(Statistics))
